$(function () {

    // 商品詳細ページ
    // 熨斗、包装、リボン　1つのみ選択可能
    $(".noshi__setting input[type='checkbox']").on("change", function(){
        $that = $(this);
        if($that.prop('checked') === true){
            $(".noshi__setting input[type='checkbox']").each(function(){
                $(this).prop('checked', false);
            })
            $that.prop('checked', true);
        }else{
            $that.prop('checked', false);
        }
        
        if($("#option01")){
            if($("#option01").prop('checked') === true){
                $(".noshi-type-wrapper").slideDown()
            }else{
                $(".noshi-type-wrapper").slideUp()
            }
        }
    })

});